import React from 'react';
import { Link } from 'react-router-dom';
import { Urls } from 'data';
import logo from 'assets/img/logo/icon_ehadj_green.svg';

const Footer = ({ year }) => (
  <footer className="static z-auto h-auto w-full bg-[#00472f] bg-none px-0 pb-[21px] pt-[54px] text-[#e3ebe5] [&_a:hover]:underline">
    <div className="mx-auto w-[calc(100%-40px)] min-[681px]:w-[calc(100%-56px)] min-[1001px]:w-[calc(100%-112px)] max-w-[1248px]">
      <div className="grid grid-cols-1 gap-8 text-sm min-[681px]:grid-cols-[1.7fr_1fr_1.2fr] min-[681px]:gap-[30px] min-[1001px]:gap-[70px]">
        <div>
          <div className="flex items-center" aria-label="eHadj">
            <div className="flex items-center gap-2">
              <img src={logo} alt="eHadj" className="h-8 w-8 object-contain" />
              <span className="-mb-1 text-2xl font-bold text-white-800">eHadj</span>
            </div>
          </div>
          <p className="mt-5 text-sm leading-[inherit] text-inherit">
            eHadj est la plateforme officielle
            <br />
            de gestion du Hajj pour le Bénin.
          </p>
        </div>
        <nav className="[&_a]:mt-2.5 [&_a]:block" aria-label="Liens rapides">
          <h2 className="mb-3 text-base font-semibold leading-[1.3] text-white min-[681px]:mb-[18px]">Liens rapides</h2>
          <a href="#presentation">À propos</a>
          <a href="#tarification">Tarification</a>
        </nav>
        <nav className="[&_a]:mt-2.5 [&_a]:block" aria-label="Informations légales">
          <h2 className="mb-3 text-base font-semibold leading-[1.3] text-white min-[681px]:mb-[18px]">
            Informations légales
          </h2>
          <Link to={Urls.legal_mention}>Mentions légales</Link>
          <Link to={Urls.cgu}>Conditions générales d’utilisation</Link>
          <Link to={Urls.cookie_policy}>Politique de gestion des cookies</Link>
        </nav>
      </div>
      <div className="mt-[42px] flex flex-wrap justify-between gap-3 border-t border-white/20 pt-[19px] text-xs">
        <span>© {year ? `${year} ` : ''}eHadj</span>
        <Link to={Urls.base}>Retour à l’accueil</Link>
      </div>
    </div>
  </footer>
);
export default Footer;
